<div class="container-fluid">
  <div class="row shadow-sm headerbar">
    <div class="col-md-2 bg-white">
      <div class="p-2">
        <img src="../../../assets/alt_logo.png" class="img-fluid logo-img mt-1 mb-1">
      </div>
    </div>
    <div class="col-md-10 bg-white">
      <div class="d-flex justify-content-between mt-1 mb-1">
        <div class="showMenu">
          <i class="bi bi-list"></i>
        </div>
        <div class="d-flex justify-content-between">
          <div class="dropdown me-4" ngbDropdown>
            <button class="btn btn-light bg-white border-0 btn-sm dropdown-toggle d-flex"
              id="dropdownBasic1" ngbDropdownToggle>
              <div>
                <img src="../../../assets/user.jpg" class="ap-avatar">
              </div>
              <div class="text-start ms-2">
                <p class="mb-0 text-bold">{{user?.name}}</p>
                <small class="text-secondary text-start">{{user?.department}} - {{user?.role}}</small>
              </div>
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownBasic1" ngbDropdownMenu>
              <a routerLink="/app/profile" class="dropdown-item">Profile</a>
              <a routerLink="/app/reset-password" class="dropdown-item">Reset Password</a>
              <a routerLink="/app/security-questions" class="dropdown-item">Security Questions</a>
              <button class="dropdown-item" (click)="onLogout()">Logout</button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-2 border-end sideMenubar">
      <div class="sidebar ps-2 pe-2">
        @for (l of sideMenu; track l) {
          @if (!l.path) {
            <a class="rounded btn btn-sm w-100 mt-2 ps-2 d-flex justify-content-between" (click)="l.visible = !l.visible">
              <div>{{l.title}}</div>
              @if (l.visible) {
                <div><i class="bi bi-chevron-down"></i></div>
              }
              @if (!l.visible) {
                <div><i class="bi bi-chevron-up"></i></div>
              }
            </a>
          }
          @if (l.visible) {
            <div>
              @for (m of l.menu; track m) {
                <div>
                  @if (m.path) {
                    <a [routerLink]="m.path" class="rounded btn btn-sm w-100"
                      [ngClass]="m.path === activeUrl ? 'btn-primary active rounded': ''">
                      <i [class]="m.icon" class="me-2"></i>
                      {{m.title}}
                    </a>
                  }
                </div>
              }
            </div>
          }
        }
      </div>
    </div>
    <div class="col-md-10 content">
      <div class="mt-2 mb-4">
        <router-outlet />
      </div>
    </div>
  </div>
</div>